export default __webpack_public_path__ + "static/media/sendchamp.59a6a26f.png";